
import { Component, Prop, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import AppAvatar from "@/components/AppAvatar.vue";
import TenantPopup from "@/components/TenantPopup.vue";
import { TenantResource } from "@/api/requests/tenant/types";
import PackageVariantIcon from "vue-material-design-icons/PackageVariant.vue";

@Component({
  components: { AppAvatar, TenantPopup, PackageVariantIcon },
})
export default class AppMenuLogo extends Vue {
  @State tenant!: TenantResource;

  @Prop(String) readonly pageName!: string;

  @Prop({ type: Boolean, default: false })
  readonly collapsed!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  private isOpen = false;

  private close() {
    this.isOpen = false;
  }

  private open() {
    if (this.disabled) {
      return;
    }

    this.isOpen = true;
  }

  toggleHamburgerMenu(){
    this.$root.$emit('toggleHamburgerMenu', true);
  }
}

